module.exports = __webpack_public_path__ + "static/media/Alkholi Group.276b26dc.png";